(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["products-related"]) return;
  try {
    
	const productRecommendationsSection = document.querySelector(
		'.js-product-related'
	);

	if (
		productRecommendationsSection &&
		!productRecommendationsSection.querySelector('.c-item-card')
	) {
		let hasLoaded = false;

		const handleIntersection = (entries, observer) => {
			const entry = entries[0];

			if (!entry.isIntersecting || hasLoaded) return;

			hasLoaded = true; // prevent re-trigger
			observer.unobserve(productRecommendationsSection);

			const url = productRecommendationsSection.dataset.url;

			fetch(url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('.js-product-related');

					if (recommendations && recommendations.innerHTML.trim().length) {
						productRecommendationsSection.innerHTML = recommendations.innerHTML;
					}
				})
				.catch((e) => {
					console.error('Failed to load product recommendations:', e);
				});
		};

		const observer = new IntersectionObserver(handleIntersection, {
			rootMargin: '0px 0px 200px 0px',
		});

		observer.observe(productRecommendationsSection);
	}

  } catch(e) { console.error(e); }
})();
})();
